module.exports = __webpack_public_path__ + "img/agenda.56b16308.png";